import { DEFAULT_DATE_LOCALE } from '@lumapps/constants';

import { TimeZone } from '../types/Time';
import { getFormattedTimezone, TimeZoneFormatOptions } from './getFormattedTimezone';
import { getTimeZoneOffset } from './getTimeZoneOffset';
import { timeZones as configuredTimeZones } from './timeZones';

interface Options extends TimeZoneFormatOptions {
    /** whether the list of timezones should be sorted alphabetically or not */
    sorted?: boolean;
    /** possibility to pass a list of timezones rather than use the predefined ones */
    timeZones?: string[];
}

/** Get formated list of time zone with id, offset and name */
export function getTimeZonesDetails(options: Options): TimeZone[] {
    const { sorted = false, timeZones = configuredTimeZones, ...rest } = options;

    const names = new Set<string>();
    const out: Array<TimeZone> = [];
    for (const timeZone of timeZones) {
        const name = getFormattedTimezone({ ...rest, timeZone });

        // Formating can create duplicates depending on granularity
        if (!names.has(name)) {
            names.add(name);
            const gmtOffset = getTimeZoneOffset({
                timeZone,
                format: 'shortOffset',
                date: rest.date,
                // Use DEFAULT_DATA_LOCAL to ensure consistency in the offset output format: GTM+XX:XX
                language: DEFAULT_DATE_LOCALE,
            });
            const offset = gmtOffset.match(/([-+]\d+)/)?.[1] as string;
            out.push({ id: timeZone, offset, name });
        }
    }

    if (sorted) {
        return out.sort((a, b) => Number(a.offset) - Number(b.offset));
    }
    return out;
}
